import { Component, OnInit } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";

import { Observable } from "rxjs";

import { DffRouteParams } from "@dffedb/router";
import { InstallationNoteService } from "@e-forsyning/common/note";

import { FeatureNoterViewModel } from "./model/feature-noter.view-model";
import { FeatureNoterSandbox } from "./services/feature-noter.sandbox";

@Component({
    selector: "feature-noter",
    styleUrls: ["./feature-noter.component.scss"],
    templateUrl: "./feature-noter.component.html"
})
export class FeatureNoterComponent implements OnInit {
    public vm$: Observable<FeatureNoterViewModel>;
    public progress$: Observable<number>;

    constructor(
        private readonly routeParams: DffRouteParams,
        public readonly service: InstallationNoteService,
        public readonly sandbox: FeatureNoterSandbox
    ) {}

    public ngOnInit(): void {
        // Vi laver lige lidt bind-trylleri, da disse funktioner bliver kaldt fra en anden komponent.
        // Vi ønsker at reference til 'this' i metoderne refererer til os selv og ikke til den kaldende komponent.
        const noteId = +this.routeParams.get("noteid");
        this.hentNote = this.hentNote.bind(this);
        this.gemNote = this.gemNote.bind(this);
        this.sletNote = this.sletNote.bind(this);
        this.vm$ = this.sandbox.hentNoter(noteId);
        this.progress$ = this.sandbox.progress$;
    }

    public hentNote(formGroup: UntypedFormGroup): Observable<UntypedFormGroup> {
        return this.sandbox.hentNote(formGroup);
    }

    public gemNote(formGroup: UntypedFormGroup): Observable<UntypedFormGroup> {
        return this.sandbox.gemNote(formGroup);
    }

    public sletNote(formGroup: UntypedFormGroup): Observable<UntypedFormGroup> {
        return this.sandbox.sletNote(formGroup);
    }
}
